import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import TransferForm from './TransferForm';
import { clearCurrentTransfer, editTransfer, loadTransferById, loadTransfers } from '../transfersReducer';
import transformer from '../../common/helpers/transformer';
import type { AppDispatch, RootState } from '../../store';
import type { Transfer as TransferType } from '../../common/types/transfer';
import { DecryptedItem } from '../../common/types/items';
import transferSelector from '../transferSelector';

type Props = {
  transferId: string;
};

function Transfer({ transferId }: Props) {
  const dispatch: AppDispatch = useDispatch();
  const [editedTransfer, updateEditedTransfer] = React.useState<TransferType | null | undefined>(null);

  const item = useSelector<RootState, DecryptedItem<TransferType> | null>(transferSelector.getCurrentTransfer);
  const transfer = item != null ? item.payload : null;

  const saveTransfer = async (transferToSave: TransferType) => {
    const payload = await transformer.fromObjectToBase64WithEncryption(transferToSave);
    await dispatch(editTransfer({ id: transferId, payload }));
    await dispatch(loadTransfers());
  };

  React.useEffect(() => {
    dispatch(loadTransferById(transferId));
    return () => {
      dispatch(clearCurrentTransfer());
    };
  }, [transferId]);

  React.useEffect(() => {
    if (item != null && editedTransfer == null) {
      updateEditedTransfer(transfer);
    }
  }, [transfer]);

  return (
    <Stack height='100%' overflow='hidden'>
      <Stack px={3} pt={3} pb={1} direction='row' justifyContent='space-between'>
        <Stack direction='row' alignItems='center'>
          <Typography fontSize='1.5rem' mr={4}>
            Übergabe
          </Typography>
        </Stack>
        <Button disabled={status === 'loading'} variant='contained' onClick={async () => {}}>
          Speichern
        </Button>
      </Stack>
      {editedTransfer != null && (
        <TransferForm transfer={editedTransfer} updateTransfer={updateEditedTransfer} saveTransfer={saveTransfer} />
      )}
    </Stack>
  );
}

export default Transfer;
